import RSSerializableBase from 'lumen/serializers/rsserializable';

export default class RSCancellationPolicySerializer extends RSSerializableBase {}
